import { FormControl, FormHelperText, InputLabel, MenuItem, Select, withStyles } from '@material-ui/core';
import React from 'react';
var AdaptableSelect = withStyles(function () { return ({
    outlined: {
        padding: '13px 14px',
        fontFamily: 'var(--main-font)',
        fontSize: '.875rem',
        color: 'var(--text1)',
    },
    disabled: {
        cursor: 'not-allowed !important',
    },
}); })(Select);
var CustomSelect = function (_a) {
    var dataTestId = _a.dataTestId, value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, errors = _a.errors, touched = _a.touched, label = _a.label, name = _a.name, disabled = _a.disabled, className = _a.className, options = _a.options, emptyValue = _a.emptyValue, fullWidth = _a.fullWidth;
    var AdaptableInputLabel = withStyles(function () { return ({
        root: {
            color: 'var(--input-label)',
            top: value ? '0' : '-4px',
            fontSize: '.875rem',
        },
        focused: {
            top: '0',
            fontSize: '.875rem',
        },
    }); })(InputLabel);
    return (React.createElement(FormControl, { variant: "outlined", className: className, disabled: disabled, error: touched && Boolean(errors), fullWidth: fullWidth },
        label ? React.createElement(AdaptableInputLabel, { id: name }, label) : null,
        React.createElement(AdaptableSelect, { id: name, name: name, value: value, onChange: onChange, onBlur: onBlur, label: label, "data-testid": dataTestId },
            emptyValue ? (React.createElement(MenuItem, { value: emptyValue.value, disabled: true }, emptyValue.label)) : null,
            options.map(function (option) { return (React.createElement(MenuItem, { value: option.value, key: option.label }, option.label)); })),
        touched && Boolean(errors) ? React.createElement(FormHelperText, null, errors) : null));
};
CustomSelect.defaultProps = {
    label: undefined,
    className: '',
    disabled: false,
    errors: undefined,
    touched: undefined,
    emptyValue: undefined,
    fullWidth: true,
};
export default CustomSelect;
